import ArticleLayout from "@/components/feature/ArticleLayout";

export default function JacketsArticle() {
  return <ArticleLayout slug="pandabuy-sheet-jackets-guide" />;
}